import { render, staticRenderFns } from "./OrderSubmit.vue?vue&type=template&id=aca1be9a&scoped=true&"
import script from "./OrderSubmit.vue?vue&type=script&lang=js&"
export * from "./OrderSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca1be9a",
  null
  
)

export default component.exports